/* WarGrounds — JS minimal (menu mobile, quantités, galerie, tri) */

/* ── i18n ──
   Les chaînes visibles par le client sont rendues par layout/theme.liquid, dans la langue
   du marché courant, et exposées via window.wgI18n. Le JS ne peut pas appeler le filtre « t » :
   il se contente de remplacer les jetons %amount% / %total% / %name% par les montants calculés.
   Le repli ci-dessous garde le texte français si le dictionnaire venait à manquer. */
var WG_I18N_FALLBACK = {
  announce_progress: 'Plus que %amount% pour la livraison offerte — panier : %total%',
  announce_reached: '✓ Livraison offerte activée — votre panier a passé le seuil des %amount%',
  add_to_cart: 'Ajouter au panier',
  cart_empty: 'Votre panier est vide — vos armées attendent leur terrain.',
  close: 'Fermer',
  decrease: 'Réduire',
  drawer_count_one: '· %total% article',
  drawer_count_other: '· %total% articles',
  gauge_empty: 'Livraison offerte dès <b>%amount%</b> · livrée en 3 à 5 jours ouvrés',
  gauge_progress: 'Votre panier : %total% — plus que <b>%amount%</b> pour la livraison offerte',
  gauge_reached: '<b>Livraison offerte</b> — votre panier (%total%) a atteint le seuil',
  increase: 'Augmenter',
  item: 'Article',
  last_position: '► Dernière position',
  remove: 'Retirer',
  remove_from_cart: 'Retirer du panier',
  resume: 'Reprendre →',
  ship_reached: '<b>Livraison offerte</b> — seuil atteint',
  ship_remaining: 'Plus que <b>%amount%</b> pour la livraison offerte',
  toast_added: '<b>%name%</b> ajouté au panier',
  view_cart: 'Voir le panier →'
};
function wgT(key, vars) {
  var dict = window.wgI18n || {};
  var s = dict[key];
  if (typeof s !== 'string' || s === '') s = WG_I18N_FALLBACK[key] || '';
  if (vars) {
    for (var k in vars) {
      if (Object.prototype.hasOwnProperty.call(vars, k)) {
        s = s.split('%' + k + '%').join(vars[k]);
      }
    }
  }
  return s;
}

/* ── Préfixe de langue ──
   Sur /de, /es ou /en, l'API panier sans préfixe (/cart.js) répond dans la langue
   principale : le tiroir affichait les titres en français, et le lien « Voir le panier »
   ramenait le visiteur sur le site français. Toute URL interne passe donc par wgUrl(). */
function wgUrl(path) {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  return root + String(path).replace(/^\//, '');
}
/* Chemin courant sans le préfixe de langue : « /de/collections/drylands » → « /collections/drylands ». */
function wgLocalPath() {
  var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  var p = window.location.pathname;
  if (root && (p === root || p.indexOf(root + '/') === 0)) p = p.slice(root.length);
  return p || '/';
}

document.addEventListener('DOMContentLoaded', function () {
  // Menu mobile
  var burger = document.querySelector('[data-wg-burger]');
  var mobileNav = document.querySelector('[data-wg-mobile-nav]');
  if (burger && mobileNav) {
    /* v1.9.1 : l'icône bascule en croix (CSS sur aria-expanded), le libellé suit,
       la page derrière ne défile plus, Échap referme. */
    var setNav = function (open) {
      mobileNav.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      var lbl = open ? burger.dataset.labelClose : burger.dataset.labelOpen;
      if (lbl) burger.setAttribute('aria-label', lbl);
      document.documentElement.classList.toggle('wg-nav-open', open);
      /* Hauteur exacte jusqu'au bas de l'écran : le bandeau d'annonce au-dessus de l'en-tête
         repoussait le menu, dont les dernières lignes (langues) sortaient de l'écran. */
      mobileNav.style.maxHeight = open ? Math.max(240, window.innerHeight - mobileNav.getBoundingClientRect().top) + 'px' : '';
    };
    burger.addEventListener('click', function () {
      setNav(!mobileNav.classList.contains('is-open'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) { setNav(false); burger.focus(); }
    });
    /* La loupe mobile ouvre le menu sur le champ de recherche au lieu de charger
       la page /search vide. Le lien reste fonctionnel sans JavaScript. */
    var searchOpen = document.querySelector('[data-wg-search-open]');
    var navInput = mobileNav.querySelector('input[type="search"]');
    if (searchOpen && navInput) {
      searchOpen.addEventListener('click', function (e) {
        if (getComputedStyle(burger).display === 'none') return;
        e.preventDefault();
        setNav(true);
        mobileNav.scrollTop = 0;
        navInput.focus();
      });
    }
  }

  // Sélecteur de langue bureau : refermer le menu déroulant au clic extérieur.
  var langMenu = document.querySelector('[data-wg-lang-menu]');
  if (langMenu) {
    document.addEventListener('click', function (e) {
      if (langMenu.open && !langMenu.contains(e.target)) langMenu.open = false;
    });
  }

  // Sélecteurs de quantité (+ / −)
  document.querySelectorAll('[data-wg-qty]').forEach(function (box) {
    var input = box.querySelector('input');
    box.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.dataset.dir === 'up' ? 1 : -1;
        var v = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) + step);
        input.value = v;
        // Sur la page panier : soumettre la mise à jour
        var form = input.closest('form[action$="/cart"]');
        if (form && input.dataset.autoSubmit === 'true') form.submit();
      });
    });
    // Entrée dans le champ : mettre à jour le panier. Sans cela, le bouton par défaut
    // du formulaire serait « Finaliser ma commande » et on partirait au paiement.
    if (input && input.dataset.autoSubmit === 'true') {
      input.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        var form = input.closest('form[action$="/cart"]');
        if (form) form.submit();
      });
    }
  });

  // Galerie produit
  var mainImg = document.querySelector('[data-wg-main-image]');
  document.querySelectorAll('[data-wg-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = t.dataset.src;
      mainImg.dataset.zoomSrc = t.dataset.src;
      mainImg.srcset = '';
      document.querySelectorAll('[data-wg-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  // Slider galerie : fleches + swipe, pilote les vignettes existantes
  var galThumbs = Array.prototype.slice.call(document.querySelectorAll('[data-wg-thumb]'));
  function wgGalGo(delta) {
    if (galThumbs.length < 2) return;
    var i = galThumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
    if (i < 0) i = 0;
    galThumbs[(i + delta + galThumbs.length) % galThumbs.length].click();
  }
  var galPrev = document.querySelector('[data-wg-gal-prev]');
  var galNext = document.querySelector('[data-wg-gal-next]');
  if (galPrev) galPrev.addEventListener('click', function (e) { e.stopPropagation(); wgGalGo(-1); });
  if (galNext) galNext.addEventListener('click', function (e) { e.stopPropagation(); wgGalGo(1); });
  var galMedia = document.querySelector('[data-wg-zoom]');
  if (galMedia && galThumbs.length > 1) {
    var galTouchX = null;
    galMedia.addEventListener('touchstart', function (e) {
      if (e.touches.length > 1) { galTouchX = null; return; }
      galTouchX = e.changedTouches[0].clientX;
    }, { passive: true });
    galMedia.addEventListener('touchend', function (e) {
      if (galTouchX === null || e.touches.length > 0) return;
      var dx = e.changedTouches[0].clientX - galTouchX;
      galTouchX = null;
      if (Math.abs(dx) > 40) wgGalGo(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  // Sélecteur de taille (fiche produit) : navigation vers le produit choisi
  var sizeSelect = document.querySelector('[data-wg-size-select]');
  if (sizeSelect) {
    sizeSelect.addEventListener('change', function () {
      if (sizeSelect.value) window.location.href = sizeSelect.value;
    });
  }

  // Tri collection
  var sort = document.querySelector('[data-wg-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      if (sort.value) { url.searchParams.set('sort_by', sort.value); }
      else { url.searchParams.delete('sort_by'); }
      window.location.href = url.toString();
    });
  }

  /* ── Ajout panier AJAX + toast (CRO : rester dans le flux d'achat) ── */
  function euros(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  /* v1.9.1 : sous-total des articles. La réponse de cart/change.js renvoie un total_price
     qui inclut le port estimé (37,97 € pour 31,98 € d'articles, vérifié le 27/10/2026) :
     le tiroir affichait alors un sous-total et une jauge faux après chaque + ou −. */
  function wgSub(c) { return c && typeof c.items_subtotal_price === 'number' ? c.items_subtotal_price : (c ? c.total_price : 0); }

  /* ── Jauge livraison offerte (fiche produit) — état réel du panier ── */
  var gauge = document.querySelector('[data-wg-shipgauge]');
  function updateGauge(cart) {
    if (!gauge) return Promise.resolve();
    var render = function (c) {
      var badge = document.querySelector('[data-wg-cart-count]');
      var threshold = parseInt((badge && badge.dataset.freeShipping) || '8000', 10);
      /* v1.9.1, lot 12 : seuil 0 = reste du monde, aucune livraison offerte (snippets/wg-franco.liquid). */
      if (!threshold) { gauge.hidden = true; return; }
      var text = gauge.querySelector('[data-wg-shipgauge-text]');
      var fill = gauge.querySelector('[data-wg-shipgauge-fill]');
      if (!c || c.item_count === 0) {
        text.innerHTML = wgT('gauge_empty', { amount: euros(threshold) });
        fill.style.width = '0%';
      } else if (wgSub(c) >= threshold) {
        text.innerHTML = wgT('gauge_reached', { total: euros(wgSub(c)) });
        fill.style.width = '100%';
      } else {
        text.innerHTML = wgT('gauge_progress', { total: euros(wgSub(c)), amount: euros(threshold - wgSub(c)) });
        fill.style.width = Math.min(100, Math.round(wgSub(c) * 100 / threshold)) + '%';
      }
      gauge.hidden = false;
    };
    if (cart) { render(cart); return Promise.resolve(); }
    return fetch(wgUrl('cart.js')).then(function (r) { return r.json(); }).then(render).catch(function () {});
  }
  updateGauge();

  /* ── Fiche produit : CTA dynamique (quantité × prix) ── */
  var buyCta = document.querySelector('[data-wg-buy-cta]');
  var buyQty = document.querySelector('[data-wg-buy] input[name=quantity]');
  var stickyQty = document.querySelector('[data-wg-sticky-qty]');
  if (buyCta && buyQty && !buyCta.disabled) {
    var unit = parseInt(buyCta.dataset.unitPrice, 10);
    var updateCta = function () {
      var q = Math.max(1, parseInt(buyQty.value, 10) || 1);
      buyCta.textContent = (buyCta.dataset.label || wgT('add_to_cart')) + ' — ' + euros(unit * q);
      if (stickyQty) stickyQty.value = q;
    };
    buyQty.addEventListener('change', updateCta);
    buyQty.addEventListener('input', updateCta);
    document.querySelectorAll('[data-wg-buy] [data-wg-qty] button').forEach(function (b) {
      b.addEventListener('click', function () { setTimeout(updateCta, 0); });
    });
  }

  /* ── Fiche produit : barre d'achat sticky quand le CTA principal sort de l'écran ── */
  var stickyBar = document.querySelector('[data-wg-sticky-buy]');
  var buyZone = document.querySelector('[data-wg-buy]');
  if (stickyBar && buyZone) {
    var stickyTick = false;
    var stickyCheck = function () {
      var r = buyZone.getBoundingClientRect();
      var show = r.bottom < 0; // le bloc d'achat est passé au-dessus de l'écran
      stickyBar.classList.toggle('is-visible', show);
      stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      stickyTick = false;
    };
    window.addEventListener('scroll', function () {
      if (!stickyTick) { stickyTick = true; requestAnimationFrame(stickyCheck); }
    }, { passive: true });
    stickyCheck();
  }

  /* ── Fiche produit : lightbox zoom (clic + pinch mobile) ── */
  var zoomWrap = document.querySelector('[data-wg-zoom]');
  if (zoomWrap && zoomWrap.querySelector('img')) {
    var lb = document.createElement('div');
    lb.className = 'wg-lightbox';
    lb.innerHTML = '<button class="wg-lightbox__close" aria-label="' + wgT('close') + '">' + wgT('close') + ' ✕</button><img alt="">';
    document.body.appendChild(lb);
    var lbImg = lb.querySelector('img');
    var lbScale = 1, lbTx = 0, lbTy = 0;
    function lbApply(anim) {
      lbImg.style.transition = anim ? 'transform .2s ease' : 'none';
      lbImg.style.transform = 'translate(' + lbTx + 'px,' + lbTy + 'px) scale(' + lbScale + ')';
    }
    function lbReset() { lbScale = 1; lbTx = 0; lbTy = 0; lbApply(false); }
    function lbOpen() {
      var main = zoomWrap.querySelector('img');
      lbImg.src = main.dataset.zoomSrc || main.src;
      lbReset();
      lb.classList.add('is-open');
    }
    function lbClose() { lb.classList.remove('is-open'); lbReset(); }
    zoomWrap.addEventListener('click', lbOpen);
    /* Pinch sur la photo principale : ouvre la visionneuse */
    zoomWrap.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2 && !lb.classList.contains('is-open')) { e.preventDefault(); lbOpen(); }
    }, { passive: false });
    lb.querySelector('.wg-lightbox__close').addEventListener('click', lbClose);
    lb.addEventListener('click', function (e) { if (e.target === lb && Date.now() - lastGesture > 350 && lbScale === 1) lbClose(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') lbClose(); });

    /* Pinch zoom + déplacement + double-tap : toute la surface de la visionneuse */
    var pDist = 0, pScale0 = 1, pPan = null, lastTap = 0, lastGesture = 0;
    function lbDist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }
    lb.addEventListener('touchstart', function (e) {
      if (e.target.classList && e.target.classList.contains('wg-lightbox__close')) return;
      if (e.touches.length === 2) { pDist = lbDist(e.touches); pScale0 = lbScale; pPan = null; lastGesture = Date.now(); }
      else if (e.touches.length === 1) {
        var now = Date.now();
        if (now - lastTap < 300) {
          lbScale = lbScale > 1 ? 1 : 2.5;
          if (lbScale === 1) { lbTx = 0; lbTy = 0; }
          lbApply(true);
          lastGesture = now;
        }
        lastTap = now;
        pPan = { x: e.touches[0].clientX - lbTx, y: e.touches[0].clientY - lbTy };
      }
    }, { passive: true });
    lb.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && pDist) {
        e.preventDefault();
        lbScale = Math.min(4, Math.max(1, pScale0 * lbDist(e.touches) / pDist));
        lbApply(false);
        lastGesture = Date.now();
      } else if (e.touches.length === 1 && pPan && lbScale > 1) {
        e.preventDefault();
        lbTx = e.touches[0].clientX - pPan.x;
        lbTy = e.touches[0].clientY - pPan.y;
        lbApply(false);
        lastGesture = Date.now();
      }
    }, { passive: false });
    lb.addEventListener('touchend', function (e) {
      if (e.touches.length === 0) {
        pDist = 0; pPan = null;
        if (lbScale <= 1.05) { lbScale = 1; lbTx = 0; lbTy = 0; lbApply(true); }
      }
    });
  }

  var toast;
  function showToast(title, cart) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'wg-toast';
      document.body.appendChild(toast);
    }
    var badge = document.querySelector('[data-wg-cart-count]');
    if (badge) badge.textContent = cart.item_count;
    var threshold = parseInt((badge && badge.dataset.freeShipping) || '8000', 10);
    var remaining = threshold - wgSub(cart);
    var shipLine = !threshold ? ''
      : remaining > 0
        ? wgT('ship_remaining', { amount: euros(remaining) })
        : wgT('ship_reached');
    toast.innerHTML =
      '<div class="wg-toast__check">✓</div>' +
      '<div class="wg-toast__body">' + wgT('toast_added', { name: title }) + (shipLine ? '<br><span>' + shipLine + '</span>' : '') + '</div>' +
      '<a href="' + wgUrl('cart') + '" class="wg-toast__cta">' + wgT('view_cart') + '</a>';
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 5000);
  }

  document.querySelectorAll('form[action$="/cart/add"], form[action*="/cart/add?"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      if (btn) { btn.disabled = true; }
      var fd = new FormData(form);
      fetch(wgUrl('cart/add.js'), { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (item) {
          // « Souvent commandé avec » : ajouter aussi le compagnon coché
          var comp = form.closest('.wg-buybox') ? form.closest('.wg-buybox').querySelector('[data-wg-companion]') : null;
          var compAdd = (comp && comp.checked)
            ? fetch(wgUrl('cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: parseInt(comp.value, 10), quantity: 1 }) }).then(function () { comp.checked = false; }).catch(function () {})
            : Promise.resolve();
          return compAdd.then(function () {
            // Sur la page panier : recharger pour rafraîchir lignes et totaux
            if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
            return fetch(wgUrl('cart.js')).then(function (r) { return r.json(); }).then(function (cart) {
              var title = (item.product_title || wgT('item')).split('—')[0].trim();
              if (comp && !comp.checked && comp.dataset.added !== 'false') { /* compagnon éventuellement ajouté */ }
              if (!wgOpenDrawer(cart)) showToast(title, cart);
              updateGauge(cart);
              updateAnnounce(cart);
            });
          });
        })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.disabled = false; } });
    });
  });

  /* ══ Personnalisation légère : préférences visiteur, UTM, panier, sans cookie tiers ══ */
  var WG_KEY = 'wg_pref';
  function wgPref() { try { return JSON.parse(localStorage.getItem(WG_KEY) || '{}'); } catch (e) { return {}; } }
  function wgSavePref(p) { try { localStorage.setItem(WG_KEY, JSON.stringify(p)); } catch (e) {} }

  /* Source de trafic : ?gamme=… ou UTM contenant un slug de gamme → préférence */
  var wgSlugs = ['drylands', 'fallen-empire', 'old-city', 'no-mans-land'];
  try {
    var qs = new URLSearchParams(window.location.search);
    var utmRaw = ((qs.get('gamme') || '') + ' ' + (qs.get('utm_content') || '') + ' ' + (qs.get('utm_campaign') || '')).toLowerCase();
    wgSlugs.forEach(function (s) {
      if (utmRaw.indexOf(s) !== -1) { var p0 = wgPref(); p0.gamme = s; wgSavePref(p0); }
    });
  } catch (e) {}

  /* Fiche produit : mémoriser la dernière position (gamme, taille, page) */
  var pmeta = document.querySelector('.wg-product[data-wg-gamme]');
  if (pmeta) {
    var pp = wgPref();
    if (pmeta.dataset.wgGamme) pp.gamme = pmeta.dataset.wgGamme;
    if (pmeta.dataset.wgSize) pp.size = pmeta.dataset.wgSize;
    pp.lastUrl = window.location.pathname;
    pp.lastTitle = (document.title || '').split('–')[0].split('—')[0].trim();
    wgSavePref(pp);
  }
  /* Page de gamme : mémoriser l'univers consulté */
  var pathBits = wgLocalPath().split('/');
  if (pathBits[1] === 'collections' && wgSlugs.indexOf(pathBits[2]) !== -1) {
    var pg = wgPref(); pg.gamme = pathBits[2]; wgSavePref(pg);
  }

  /* Home : best-sellers réordonnés sur la gamme préférée + barre « reprendre » */
  if (wgLocalPath() === '/') {
    var pref = wgPref();
    var bestGrid = document.querySelector('#bestsellers .wg-product-grid');
    if (bestGrid && pref.gamme) {
      var prefCards = Array.prototype.slice.call(bestGrid.querySelectorAll('.wg-card[data-gamme="' + pref.gamme + '"]'));
      prefCards.reverse().forEach(function (c) { bestGrid.insertBefore(c, bestGrid.firstElementChild); });
    }
    var bestWrap = document.querySelector('#bestsellers .wg-container');
    if (bestWrap && pref.lastUrl && pref.lastTitle) {
      var bar = document.createElement('a');
      bar.className = 'wg-resume';
      bar.href = pref.lastUrl;
      var k = document.createElement('span'); k.className = 'wg-resume__k'; k.textContent = wgT('last_position');
      var t = document.createElement('b'); t.textContent = pref.lastTitle;
      var c2 = document.createElement('span'); c2.className = 'wg-resume__cta'; c2.textContent = wgT('resume');
      bar.appendChild(k); bar.appendChild(t); bar.appendChild(c2);
      bestWrap.insertBefore(bar, bestWrap.firstElementChild);
    }
  }

  /* Bandeau d'annonce : bascule sur l'état réel du panier dès qu'il n'est pas vide */
  function updateAnnounce(cart) {
    var el = document.querySelector('[data-wg-announce-cart]');
    var def = document.querySelector('[data-wg-announce-default]');
    if (!el || !cart || cart.item_count === 0) return;
    var badge = document.querySelector('[data-wg-cart-count]');
    var threshold = parseInt((badge && badge.dataset.freeShipping) || '8000', 10);
    if (!threshold) return;
    if (wgSub(cart) >= threshold) {
      el.textContent = wgT('announce_reached', { amount: euros(threshold) });
    } else {
      el.textContent = wgT('announce_progress', { amount: euros(threshold - wgSub(cart)), total: euros(wgSub(cart)) });
    }
    el.hidden = false;
    if (def) def.hidden = true;
  }
  fetch(wgUrl('cart.js')).then(function (r) { return r.json(); }).then(function (cart) {
    updateAnnounce(cart);
    var badge = document.querySelector('[data-wg-cart-count]');
    if (badge && cart) badge.textContent = cart.item_count;
  }).catch(function () {});

  /* ── Ambiance : kickers en machine à écrire à l'apparition ── */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var typeKicker = function (el) {
      if (el.dataset.typed) return;
      el.dataset.typed = '1';
      var txt = el.textContent;
      el.textContent = '';
      el.classList.add('is-typing');
      var i = 0;
      var t = setInterval(function () {
        i += 1;
        el.textContent = txt.slice(0, i);
        if (i >= txt.length) { clearInterval(t); el.classList.remove('is-typing'); }
      }, 16);
    };
    var kickers = document.querySelectorAll('.wg-kicker');
    if ('IntersectionObserver' in window) {
      var kio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { typeKicker(e.target); kio.unobserve(e.target); }
        });
      }, { threshold: 0.4 });
      kickers.forEach(function (k) { kio.observe(k); });
    }
  }

  /* ══ Drawer panier — ouvert après ajout, contenu depuis /cart.js ══ */
  var wgDrawer = document.querySelector('[data-wg-drawer]');

  function wgDrawerRefreshAll(cart) {
    var badge = document.querySelector('[data-wg-cart-count]');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.classList.remove('is-burst');
      void badge.offsetWidth; /* redémarre l'animation */
      badge.classList.add('is-burst');
    }
    updateGauge(cart);
    updateAnnounce(cart);
  }

  function wgDrawerRender(cart) {
    var linesBox = wgDrawer.querySelector('[data-wg-drawer-lines]');
    var count = wgDrawer.querySelector('[data-wg-drawer-count]');
    var subtotal = wgDrawer.querySelector('[data-wg-drawer-subtotal]');
    count.textContent = cart.item_count > 1
      ? wgT('drawer_count_other', { total: cart.item_count })
      : wgT('drawer_count_one', { total: cart.item_count });
    subtotal.textContent = euros(wgSub(cart));
    linesBox.innerHTML = '';

    cart.items.forEach(function (it) {
      var row = document.createElement('div');
      row.className = 'wg-drawer__line';

      var img = document.createElement('img');
      if (it.image) img.src = it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      img.alt = ''; img.width = 56; img.height = 56; img.loading = 'lazy';
      row.appendChild(img);

      var mid = document.createElement('div');
      var t = document.createElement('b');
      t.textContent = (it.product_title || '').split('—')[0].trim();
      var m = document.createElement('small');
      m.textContent = ((it.product_title || '').split('—')[1] || '').trim();
      var qty = document.createElement('div');
      qty.className = 'wg-drawer__qty';
      var minus = document.createElement('button'); minus.type = 'button'; minus.textContent = '−'; minus.setAttribute('aria-label', wgT('decrease'));
      var qv = document.createElement('span'); qv.textContent = it.quantity;
      var plus = document.createElement('button'); plus.type = 'button'; plus.textContent = '+'; plus.setAttribute('aria-label', wgT('increase'));
      qty.appendChild(minus); qty.appendChild(qv); qty.appendChild(plus);
      mid.appendChild(t); mid.appendChild(m); mid.appendChild(qty);
      row.appendChild(mid);

      var right = document.createElement('div');
      right.className = 'wg-drawer__right';
      var price = document.createElement('b');
      price.textContent = euros(it.final_line_price);
      var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'wg-drawer__rm'; rm.textContent = wgT('remove'); rm.setAttribute('aria-label', wgT('remove_from_cart'));
      right.appendChild(price); right.appendChild(rm);
      row.appendChild(right);

      function change(q) {
        fetch(wgUrl('cart/change.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: q })
        }).then(function (r) { return r.json(); }).then(function (c2) {
          wgDrawerRender(c2);
          wgDrawerRefreshAll(c2);
        }).catch(function () {});
      }
      minus.addEventListener('click', function () { change(Math.max(0, it.quantity - 1)); });
      plus.addEventListener('click', function () { change(it.quantity + 1); });
      rm.addEventListener('click', function () { change(0); });

      linesBox.appendChild(row);
    });

    if (cart.item_count === 0) {
      var empty = document.createElement('p');
      empty.className = 'wg-drawer__empty';
      empty.textContent = wgT('cart_empty');
      linesBox.appendChild(empty);
    }

    /* Jauge livraison du drawer */
    var gtext = wgDrawer.querySelector('[data-wg-drawer-gauge-text]');
    var gfill = wgDrawer.querySelector('[data-wg-drawer-gauge-fill]');
    var badge = document.querySelector('[data-wg-cart-count]');
    var threshold = parseInt((badge && badge.dataset.freeShipping) || '8000', 10);
    if (gtext && gfill && !threshold) {
      gtext.parentElement.hidden = true;
    } else if (gtext && gfill) {
      if (wgSub(cart) >= threshold) {
        gtext.innerHTML = wgT('ship_reached');
        gfill.style.width = '100%';
      } else {
        gtext.innerHTML = wgT('ship_remaining', { amount: euros(threshold - wgSub(cart)) });
        gfill.style.width = Math.min(100, Math.round(wgSub(cart) * 100 / threshold)) + '%';
      }
    }
  }

  function wgOpenDrawer(cart) {
    if (!wgDrawer) return false;
    wgDrawerRender(cart);
    wgDrawer.classList.add('is-open');
    wgDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    return true;
  }
  function wgCloseDrawer() {
    if (!wgDrawer) return;
    wgDrawer.classList.remove('is-open');
    wgDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (wgDrawer) {
    wgDrawer.querySelectorAll('[data-wg-drawer-close]').forEach(function (b) {
      b.addEventListener('click', wgCloseDrawer);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') wgCloseDrawer(); });
  }
});
